import { useState, useEffect } from "react";
import "./createProvider.css";
import Select, { components } from "react-select";
import SideMenu from "../../features/sideMenu/SideMenu";
import CustomButton from "../../ui/button/Button";
import { useParams } from "react-router-dom";
import { fetchProviderById, updateProvider } from "../functions/Functions";
import {
  fieldsAddProviderBank,
  fieldsAddProviderContact,
  fieldsAddProviderData,
  fieldsAddProvider,
} from "../../constants/addUser.constats";
import { SpecialtiesSelector } from "../functions/Providers";
import MapModal from "../../ui/map/MapaModal";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import { useNavigate } from "react-router-dom";
import { itemsProviders } from "../../constants/providers";
import "./EditProvider.responsive.css";
import DropdownCaret from "../../ui/select/DropDown";

const EditProvider = ({ API_URL, states, specialties, status }) => {
  const { id } = useParams();

  const initialState = {
    razonSocial: "",
    rfc: "",
    direccionFiscal: "",
    fechaInscripcion: "",
    estatusEmpresa: { nombre: "" },
    institucionBancaria: "",
    numCuenta: "",
    clabeInterbancaria: "",
    sucursal: "",
    habilitada: false,
    nombre: "",
    apellidos: "",
    telefono: "",
    email: "",
    calificacion: "",
    cobertura: "",
    capacidadInstalaciones: 0,
    instalacionesActivas: 0,
    comentarios: "",
    aptitudes: "",
    latitude: "",
    longitude: "",
    direccionBusqueda: "",
    especialidades: [],
    numGafete: "",
    numbreContacto: "",
    icon: "",
    progresoMultimediaContactos: 0,
    buscarInhabilitadas: false,
    perfilInstalador: null,
    especialidadesSelec: [],
  };

  const [payload, setPayload] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const showDialog = useConfirmDialog();
  const navigate = useNavigate();

  const handleLocationSelect = (location) => {
    setPayload((prev) => ({
      ...prev,
      direccionFiscal: location.address,
      latitude: location.lat,
      longitude: location.lng,
    }));
  };

  const handleMultiSelectChange = (field, selectedOptions) => {
    setPayload((prev) => ({
      ...prev,
      [field]: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    }));
  };

  const adaptPayloadForUpdate = (formData) => {
    const coberturaTexto = states
      .filter((state) => payload.cobertura.includes(state.id))
      .map((state) => state.nombreEstado)
      .join(",");

    const especialidadesFinal = specialties
      .filter((esp) => formData.especialidades.includes(esp.id))
      .map((esp) => ({ ...esp, asignada: true }));
    const estatusEmpresa = status.find(
      (statu) => statu.id === formData.estatusEmpresa?.id
    );
    const aptitudes = especialidadesFinal.map((esp) => esp.nombre).join(",");
    const especialidades = specialties.map((esp) => ({
      ...esp,
      asignada: formData.especialidadesSelec.includes(esp.id),
    }));

    return {
      ...formData,
      aptitudes,
      cobertura: coberturaTexto,
      estados: states.filter((s) => payload.cobertura.includes(s.id)),
      especialidades,
      especialidadesSelec: especialidadesFinal,
      estatusEmpresa: estatusEmpresa || null,
      direccionBusqueda: formData.direccionFiscal,
      porDefecto: true,
      perfilInstalador: {
        id: 2,
        descripcion:
          "Encargado o responsable de los trabajos en sitio, personal autorizado para trabajos de alto riesgo (eléctricos, alturas)",
        documentosNecesarios: "FOTO,INE,IMSS,CERTIFICADO_MEDICO,DC3,CREDENCIAL",
        nombre: "LÍDER DE CUADRILLA",
      },
      numGafete: formData.numGafete?.startsWith("TEMP_")
        ? formData.numGafete
        : `TEMP_${formData.rfc}`,
    };
  };

  const handleSave = async () => {
    try {
      const adaptedPayload = adaptPayloadForUpdate(payload);
      await updateProvider(API_URL, adaptedPayload);
      showDialog({
        html: "La empresa fue actualizada con éxito.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
        onConfirm: () => navigate("/proveedores/todos"),
      });
    } catch (error) {
      showDialog({
        html: `Ocurrió un error al actualizar la empresa.<br>${error.response.data.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetchProviderById(API_URL, id);
        const coberturaNombres = response.cobertura
          ? response.cobertura.split(",").map((estado) => estado.trim())
          : [];
        const coberturaIDs = states
          .filter((state) => coberturaNombres.includes(state.nombreEstado))
          .map((state) => state.id);
        setPayload({
          ...response,
          especialidades: response.especialidades
            ? response.especialidades.map((e) => e.id)
            : [],
          especialidadesSelec: response.especialidadesSelec
            ? response.especialidadesSelec.map((e) => e.id)
            : [],
          cobertura: coberturaIDs,
        });
      } catch (error) {
        console.error("Error al cargar los datos de la empresa:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, [API_URL, id, states]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  if (isLoading) {
    return <p>Cargando datos...</p>;
  }

  return (
    <div
      className="editProvider-container"
      style={{ display: "flex", height: "100%" }}
    >
      <div className="editProvider-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>
      <div className="editProvider-main createUser">
        <div className="form-container">
          <form>
            <h1>Información general:</h1>
            <div className="row two-column-section">
              {fieldsAddProvider?.map((field) => (
                <div
                  className={`form-row ${
                    field.name === "direccionFiscal" ? "full-width" : ""
                  }`}
                  key={field.name}
                >
                  <div>
                    {field.name === "direccionFiscal" ? (
                      <>
                        <div className="form-row full-width" key={field.name}>
                          <div className="d-flex flex-column">
                            <label className="form-label">{field.label}:</label>
                            <input
                              className="form-input"
                              type="text"
                              name="direccionFiscal"
                              value={payload.direccionFiscal}
                              readOnly
                              placeholder="Selecciona una dirección"
                              onClick={(e) => {
                                e.target.blur();
                                setTimeout(() => setIsMapModalOpen(true), 0);
                              }}
                            />
                          </div>
                        </div>

                        <div className="form-row">
                          <div
                            className="d-flex justify-content-between"
                            style={{ gap: "2rem" }}
                          >
                            <div
                              className="d-flex flex-column"
                              style={{ width: "100%" }}
                            >
                              <label className="form-label">Latitud:</label>
                              <input
                                className="form-input"
                                type="text"
                                name="latitude"
                                value={payload.latitude || ""}
                                readOnly
                                placeholder="Latitud"
                              />
                            </div>
                            <div
                              className="d-flex flex-column"
                              style={{ width: "100%" }}
                            >
                              <label className="form-label">Longitud:</label>
                              <input
                                className="form-input"
                                type="text"
                                name="longitude"
                                value={payload.longitude || ""}
                                readOnly
                                placeholder="Longitud"
                              />
                            </div>
                          </div>
                        </div>

                        {isMapModalOpen && (
                          <div className="map-floating-modal">
                            <MapModal
                              key={isMapModalOpen ? "open" : "closed"}
                              onClose={() => setIsMapModalOpen(false)}
                              onSelectLocation={handleLocationSelect}
                              initialLocation={{
                                lat: payload.latitude || 19.4326,
                                lng: payload.longitude || -99.1332,
                                address: payload.direccionFiscal,
                              }}
                            />
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="form-row" key={field.name}>
                        <div className="d-flex flex-column">
                          <label className="form-label">{field.label}:</label>
                          <input
                            className="form-input"
                            type={
                              field.name === "fechaInscripcion"
                                ? "date"
                                : "text"
                            }
                            name={field.name}
                            value={payload[field.name] || ""}
                            onChange={handleChange}
                            placeholder={`Ingresa ${
                              field.label === "RFC"
                                ? "RFC"
                                : field.label.toLowerCase()
                            }`}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <h1>Datos Adicionales:</h1>
            <div className="row two-column-section">
              {fieldsAddProviderData?.map((field) => (
                <div className="form-row" key={field.name}>
                  {" "}
                  <div className="d-flex flex-column">
                    <label className="form-label">{field.label}:</label>
                    {field.name === "especialidades" ? (
                      <SpecialtiesSelector
                        specialties={specialties}
                        selectedSpecialties={payload.especialidadesSelec || []}
                        onChange={(selectedSpecialties) =>
                          setPayload((prev) => ({
                            ...prev,
                            especialidades: selectedSpecialties,
                            especialidadesSelec: selectedSpecialties,
                          }))
                        }
                      />
                    ) : field.name === "estatus" ? (
                      (() => {
                        const baseOptions = (status || []).map((statu) => ({
                          value: statu.id,
                          label: statu.nombre,
                        }));

                        // opción placeholder visible en el menú
                        const placeholderOption = {
                          value: "",
                          label: "Seleccione un estatus",
                        };

                        // opciones finales (placeholder + reales)
                        const statusOptions = [
                          placeholderOption,
                          ...baseOptions,
                        ];

                        // valor seleccionado: usa el placeholder si no hay estatus
                        const selectedOption =
                          statusOptions.find(
                            (o) =>
                              o.value === (payload.estatusEmpresa?.id ?? "")
                          ) || placeholderOption;

                        return (
                          <div style={{ width: 500, height: 30 }}>
                            <Select
                              options={statusOptions}
                              value={selectedOption}
                              onChange={(opt) => {
                                const selectedStatus = (status || []).find(
                                  (s) => s.id === (opt?.value ?? null)
                                );
                                setPayload((prev) => ({
                                  ...prev,
                                  estatusEmpresa: selectedStatus || null, // si eligen el placeholder (""), queda null
                                }));
                              }}
                              isSearchable={false}
                              components={{
                                DropdownIndicator: DropdownCaret,
                                IndicatorSeparator: null,
                              }}
                              maxMenuHeight={9999}
                              styles={{
                                container: (b) => ({ ...b, width: "100%" }),
                                control: (b, s) => ({
                                  ...b,
                                  minHeight: 30,
                                  height: 30,
                                  borderRadius: 5,
                                  borderColor: s.isFocused ? "#62C776" : "#ccc",
                                  boxShadow: "none",
                                  "&:hover": {
                                    borderColor: s.isFocused
                                      ? "#62C776"
                                      : "#ccc",
                                  },
                                }),
                                valueContainer: (b) => ({
                                  ...b,
                                  padding: "0 6px",
                                }),
                                singleValue: (b) => ({
                                  ...b,
                                  fontSize: 16,
                                  color: "#6c757d",
                                  textAlign: "left",
                                  marginBlockEnd: "auto",
                                }),
                                placeholder: (b) => ({
                                  ...b,
                                  fontSize: 16,
                                  color: "#666",
                                  textAlign: "left",
                                }),
                                menu: (b) => ({
                                  ...b,
                                  zIndex: 9999,
                                  textAlign: "left",
                                  overflow: "visible",
                                }),
                                menuList: (b) => ({
                                  ...b,
                                  maxHeight: "none",
                                  overflowY: "visible",
                                  paddingTop: 0,
                                  paddingBottom: 0,
                                }),
                                option: (b, s) => ({
                                  ...b,
                                  textAlign: "left",
                                  color: "#000",
                                  backgroundColor: s.isSelected
                                    ? "#e0e0e0"
                                    : s.isFocused
                                    ? "#f2f2f2"
                                    : "#fff",
                                }),
                                indicatorsContainer: (b) => ({
                                  ...b,
                                  height: 30,
                                }),
                                dropdownIndicator: (b) => ({
                                  ...b,
                                  paddingTop: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 4,
                                  paddingRight: 8,
                                }),
                                indicatorSeparator: () => ({ display: "none" }),
                              }}
                            />
                          </div>
                        );
                      })()
                    ) : field.name === "cobertura" ? (
                      <div
                        className="coverage-select-wrap"
                        style={{ width: "500px" }}
                      >
                        <Select
                          options={states.map((state) => ({
                            value: state.id,
                            label: state.nombreEstado,
                          }))}
                          isMulti
                          components={{ DropdownIndicator: DropdownCaret }}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "40px",
                              maxHeight: "auto",
                              overflowY: "auto",
                              backgroundColor: "#fff",
                              borderColor: state.isFocused ? "#62C776" : "#ccc",
                              boxShadow: state.isFocused
                                ? "0 0 3px #62C776"
                                : "none",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              display: "flex",
                              flexWrap: "wrap",
                              overflowY: "auto",
                              maxHeight: "150px",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: "#000",
                              backgroundColor: state.isSelected
                                ? "#e0e0e0"
                                : "white",
                              "&:hover": {
                                backgroundColor: "#f0f0f0",
                              },
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              backgroundColor: "#62C776",
                              color: "#fff",
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              color: "#fff",
                            }),
                            multiValueRemove: (provided) => ({
                              ...provided,
                              color: "#fff",
                              ":hover": {
                                backgroundColor: "#ff6b6b",
                                color: "#fff",
                              },
                            }),
                          }}
                          value={states
                            .filter((state) =>
                              payload.cobertura.includes(state.id)
                            )
                            .map((state) => ({
                              value: state.id,
                              label: state.nombreEstado,
                            }))}
                          onChange={(selectedOptions) =>
                            handleMultiSelectChange(
                              "cobertura",
                              selectedOptions || []
                            )
                          }
                          placeholder="Selecciona cobertura"
                          classNamePrefix="react-select"
                        />
                      </div>
                    ) : field.name === "especialidades" ? (
                      <SpecialtiesSelector
                        specialties={specialties}
                        selectedSpecialties={payload.especialidades || []}
                        onChange={(specialties) =>
                          setPayload((prev) => ({
                            ...prev,
                            especialidades: specialties,
                          }))
                        }
                      />
                    ) : (
                      <input
                        className="form-input"
                        type="text"
                        name={field.name}
                        value={payload[field.name] || ""}
                        onChange={handleChange}
                        placeholder={`Ingresa ${field.label.toLowerCase()}`}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>

            <h1>Contacto Información:</h1>
            <div className="row two-column-section">
              {fieldsAddProviderContact?.map((field) => (
                <div className="form-row" key={field.name}>
                  {" "}
                  <div className="d-flex flex-column">
                    <label className="form-label">{field.label}:</label>
                    <input
                      className="form-input"
                      type="text"
                      name={field.name}
                      value={payload[field.name] || ""}
                      onChange={handleChange}
                      placeholder={`Ingresa ${field.label.toLowerCase()}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            <h1>Datos Bancarios:</h1>
            <div className="row two-column-section">
              {fieldsAddProviderBank?.map((field) => (
                <div className="form-row" key={field.name}>
                  <div className="d-flex flex-column">
                    <label className="form-label">{field.label}:</label>
                    <input
                      className="form-input"
                      type="text"
                      name={field.name}
                      value={payload[field.name] || ""}
                      onChange={handleChange}
                      placeholder={`Ingresa ${field.label.toLowerCase()}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="button-container">
              <CustomButton
                text={"Guardar"}
                color={"#FFFFFF"}
                border={"none"}
                background={"#62C776"}
                fontStyle={"normal"}
                fontWeight={700}
                fontSize={"14px"}
                width={"75px"}
                height={"28px"}
                type={"button"}
                onClick={() => handleSave()}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProvider;
